"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Error boundary caught:", error);
    // Mostrar al usuario el digest para poder correlacionarlo con los
    // function logs de Vercel donde sí aparece la causa raíz.
    if (error?.digest) {
      console.error("[digest]", error.digest, "url:", typeof window !== "undefined" ? window.location.href : null);
    }
  }, [error]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="text-center space-y-4 p-8">
        <h2 className="text-xl font-semibold text-text">Algo salió mal</h2>
        <p className="text-sm text-text-muted">Ocurrió un error inesperado.</p>
        {error?.digest && (
          <p className="text-[11px] font-mono text-text-muted opacity-70">
            ID de error: {error.digest}
          </p>
        )}
        <button
          // RECARGA REAL (29 jul): reset() re-renderizaba el MISMO bundle
          // roto — en la PWA con un chunk viejo cacheado, "Reintentar" era
          // un loop sin salida. La recarga trae el shell nuevo del server
          // (y de paso actualiza el service worker).
          onClick={() => {
            try {
              window.location.reload();
            } catch {
              reset();
            }
          }}
          className="rounded-xl bg-accent px-6 py-3 text-sm font-medium text-white transition hover:bg-accent/90"
        >
          Reintentar
        </button>
      </div>
    </div>
  );
}
